import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PutInvoiceLineFormFields {

    public amount: FormField
    public quantity: FormField
    public description: FormField
    public price: FormField
    public invoice: FormField

    constructor() {

        this.amount = new FormField(
          'amount',
          'Amount',
          null,
          FormFieldType.text,
          false,
        )
        this.quantity = new FormField(
          'quantity',
          'Quantity',
          null,
          FormFieldType.text,
          false,
        )
        this.description = new FormField(
          'description',
          'Description',
          null,
          FormFieldType.text,
          false,
          true,
          ""
        )
        this.price = new FormField(
          'price',
          'Price',
          'price',
          FormFieldType.pushedSelectionList,
          false,
        )
        this.invoice = new FormField(
          'invoice',
          'Invoice',
          'invoice',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutInvoiceLineFormFields()

export const putInvoiceLineFormFieldOptions: {[key: string]: FormField} = {
  amount: fields.amount,
  quantity: fields.quantity,
  description: fields.description,
  price: fields.price,
  invoice: fields.invoice,
};